export const hellixBold = `font-family: 'Hellix-Bold', 'Hellix', sans-serif;`;
export const hellixSemiBold = `font-family: 'Hellix-SemiBold', 'Hellix', sans-serif;`;
export const hellixMedium = `font-family: 'Hellix-Medium', 'Hellix', sans-serif;`;
